import { render, staticRenderFns } from "./ReviewDependencyComponent.vue?vue&type=template&id=8ca954ae&scoped=true&"
import script from "./ReviewDependencyComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewDependencyComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDependencyComponent.vue?vue&type=style&index=0&id=8ca954ae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca954ae",
  null
  
)

export default component.exports